if (!customElements.get('clovant-sticky-purchase')) {
  customElements.define(
    'clovant-sticky-purchase',
    class ClovantStickyPurchase extends HTMLElement {
      cartUpdateUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;
      animationFrame = undefined;
      resetTimer = undefined;

      constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
        this.scheduleVisibilityUpdate = this.scheduleVisibilityUpdate.bind(this);
        this.syncQuantity = this.syncQuantity.bind(this);
        this.resetSubmitting = this.resetSubmitting.bind(this);
      }

      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.purchaseTarget = document.getElementById(this.dataset.purchaseTarget);
        this.quantityInput = this.productInfo?.querySelector('.quantity__input');

        this.addEventListener('click', this.handleClick);
        this.quantityInput?.addEventListener('change', this.syncQuantity);
        window.addEventListener('scroll', this.scheduleVisibilityUpdate, { passive: true });
        window.addEventListener('resize', this.scheduleVisibilityUpdate);

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.resetSubmitting);
        this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, this.resetSubmitting);

        this.syncQuantity();
        this.scheduleVisibilityUpdate();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.quantityInput?.removeEventListener('change', this.syncQuantity);
        window.removeEventListener('scroll', this.scheduleVisibilityUpdate);
        window.removeEventListener('resize', this.scheduleVisibilityUpdate);
        this.cartUpdateUnsubscriber?.();
        this.cartErrorUnsubscriber?.();
        window.cancelAnimationFrame(this.animationFrame);
        window.clearTimeout(this.resetTimer);
      }

      handleClick(event) {
        const stickyButton = event.target.closest('[data-clovant-sticky-submit]');
        if (!stickyButton || !this.contains(stickyButton)) return;

        const productForm = this.productInfo?.querySelector('product-form');
        const submitButton = productForm?.querySelector('[name="add"]');
        if (!productForm || !submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        stickyButton.disabled = true;
        stickyButton.setAttribute('aria-busy', 'true');
        productForm.form.requestSubmit(submitButton);

        window.clearTimeout(this.resetTimer);
        this.resetTimer = window.setTimeout(this.resetSubmitting, 8000);
      }

      resetSubmitting() {
        const stickyButton = this.querySelector('[data-clovant-sticky-submit]');
        if (!stickyButton) return;

        stickyButton.disabled = false;
        stickyButton.removeAttribute('aria-busy');
        window.clearTimeout(this.resetTimer);
      }

      syncQuantity() {
        const quantityOutput = this.querySelector('[data-clovant-sticky-quantity]');
        if (quantityOutput && this.quantityInput) quantityOutput.textContent = this.quantityInput.value;
      }

      scheduleVisibilityUpdate() {
        if (this.animationFrame) return;
        this.animationFrame = window.requestAnimationFrame(() => {
          this.animationFrame = undefined;
          this.updateVisibility();
        });
      }

      updateVisibility() {
        if (!this.productInfo || !this.purchaseTarget) return;

        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const headerBottom = document.querySelector('sticky-header')?.getBoundingClientRect().bottom || 0;
        const purchaseBottom = this.purchaseTarget.getBoundingClientRect().bottom;
        const productBottom = this.productInfo.getBoundingClientRect().bottom;
        const barHeight = this.getBoundingClientRect().height;
        const shouldShow = isMobile && purchaseBottom <= headerBottom && productBottom > barHeight + 16;

        this.toggleAttribute('visible', shouldShow);
        this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }
    }
  );
}
